import React, { useState, useEffect } from "react";
import { usePersistData } from "../../store";
import { Icon } from "../../components";
import {
  adminMenu,
  employeeMenu,
  lineManagerMenu,
  resetPassword,
  strings,
} from "../../utils";
import { useLocation, useNavigate } from "react-router-dom";
import LogOutIcon from "../../components/Icons/logOutIcon";
import { auth } from "../../services";
import Button from "../../components/Button";
import { Profile } from "../../assets/images";
import ResetLinkModal from "../Login/ResetPassword";

const Dashboard = () => {
  const { user, setUser } = usePersistData();
  const [selected, setSelected] = useState("blog");
  const [isResetModalOpen, setIsResetModalOpen] = useState(false);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const navigate = useNavigate();

  const openResetModal = async () => {
    // setIsResetModalOpen(true);
    await resetPassword(user.email);
  };
  const closeResetModal = () => setIsResetModalOpen(false);

  const openLogoutModal = () => setIsLogoutModalOpen(true);
  const closeLogoutModal = () => setIsLogoutModalOpen(false);

  const handleLogout = () => {
    logout();
    localStorage.removeItem("user");
    navigate("/login");
    closeLogoutModal();
  };

  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname.split("/")[1];
    setSelected(currentPath || "blog");
  }, [location]);

  const handleProfileClick = () => {
    navigate("/userProfile");
  };

  const logout = async () => {
    await auth.signOut();
    setUser(null);
    navigate("/login");
  };

  const menu =
    user?.designation === "EMPLOYEE" && !user?.managedEmployees
      ? employeeMenu
      : user?.designation === "EMPLOYEE" && !!user?.managedEmployees
        ? lineManagerMenu
        : user?.designation === "ADMIN" || user?.designation === "HR"
          ? adminMenu
          : [];

  return (
    <div className="w-[280px] h-screen bg-white py-[34px] px-4 flex flex-col justify-between border-r border border-color-6">
      <div>
        <span className="flex justify-center">
          <Icon />
        </span>
        <div className="mt-10 space-y-2">
          {menu.map((v, i) => {
            return (
              <div
                key={i}
                className={`flex px-3 py-[10px] text-color-1 rounded-md space-x-2 cursor-pointer ${selected === v.icon && "bg-primary text-white"
                  }`}
                onClick={() => {
                  navigate(`/${v.icon}`);
                  setSelected(v.icon);
                }}
              >
                <Icon iconName={v.icon} />
                <span>{v.title}</span>
              </div>
            );
          })}
        </div>
      </div>
      <div>
        <p
          className={`flex px-3 py-[10px] text-color-1 rounded-md space-x-2 cursor-pointer`}
          onClick={openResetModal}
        >
          {strings["resetPassword"]}
        </p>

        <ResetLinkModal isOpen={isResetModalOpen} onClose={closeResetModal} />

        <hr />
        <div className="flex justify-between items-center">
          <div className="flex items-center mt-6 gap-x-3">
            <p onClick={handleProfileClick}>
              <div className="w-[40px] h-[40px]">
                {user?.employeeImageUrl ? (
                  <img
                    src={user.employeeImageUrl}
                    alt="User Profile"
                    className="rounded-full w-10 h-10"
                    style={{ objectFit: "cover" }}
                  />
                ) : (
                  <img
                    src={Profile}
                    alt="User Profile"
                    className="rounded-full w-10 h-10 "
                  />
                )}
              </div>
            </p>

            <div className="flex flex-col">
              <p className="text-sm font-semibold">
                {user?.firstName || "Guest"}
              </p>
              <p className="text-sm font-normal text-color-8">
                {user?.email || "No email available"}
              </p>
            </div>
          </div>
          <div className="border border-white p-2 w-9 h-9 mt-6">
            <Button className="bg-white border-white" onClick={openLogoutModal}>
              <LogOutIcon />
            </Button>
          </div>

          {isLogoutModalOpen && (
            <div
              className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
              onClick={closeLogoutModal}
            >
              <div
                className="bg-white rounded-lg shadow-lg p-6 w-96"
                onClick={(e) => e.stopPropagation()}
              >
                <h2 className="text-xl font-semibold mb-4">Confirm Logout</h2>
                <p className="text-gray-600 mb-6">
                  Are you sure you want to log out?
                </p>
                <div className="flex justify-end space-x-2">
                  <button
                    className="px-4 py-2 bg-color-4 rounded text-white"
                    onClick={closeLogoutModal}
                  >
                    No
                  </button>
                  <button
                    className="px-4 py-2 bg-primary text-white rounded"
                    onClick={handleLogout}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
